/**
 * Ét sted at spørge om hvilken udgave brugeren kører.
 *
 * Værdierne stemples ind ved byggetid af vite.config.ts (`define`) og kommer fra to
 * slags kilder:
 *  - version/isBeta: package.json, altså et menneskeligt valg ved udgivelse.
 *  - build/commit/buildDate: CI. swa.yml sender BUILD_NUMBER (github.run_number),
 *    GITHUB_SHA følger med ind i byggeriet, og buildDate er byggetidspunktet —
 *    som her er deploytidspunktet, fordi byggeriet sker som en del af deployet.
 *
 * Der er derfor intet at vedligeholde i hånden ved et deploy.
 */
export interface BuildInfo {
  /** Udgivelsen er en beta, dvs. package.json-versionen bærer en prerelease-tag. */
  isBeta: boolean
  /** Udgivelsesnummer uden prerelease-tag, fx "0.6.1". */
  version: string
  /** Deploy-nummer fra CI. "0" i en lokal build. */
  build: string
  /** Commit-sha (7 tegn), eller "dev-<dato>" lokalt. */
  commit: string
  /** ISO-tidspunkt for byggeriet/deployet. */
  buildDate: string
}

export const buildInfo: BuildInfo = {
  isBeta: __APP_IS_BETA__,
  version: __APP_VERSION__,
  build: __APP_BUILD_NUMBER__,
  commit: __APP_COMMIT__,
  buildDate: __APP_BUILT__,
}
